






























































































import { Vue, Component } from "vue-property-decorator";
import VueBase from "@/lib/vuebase";
import ajax from "@/lib/ajax";
import util from "@/lib/util";
import MaintainRecordDto from "@/store/models/maintain/maintainrecord";
@Component({})
export default class StatementDetail extends VueBase {
  checked: boolean = false;
  value: number = 1;
  partsAllList: Array<any> = [];
  loading: boolean = false;
  dispatchFormData: MaintainRecordDto = new MaintainRecordDto();
  showHandleType: boolean = false;
  userName: string = "";
  fileList: Array<any> = [];
  uploadUrls: Array<string> = [];
  isUploadSuccess: boolean = true;
  handleTypes = [
    { value: "现场处理", text: "现场处理" },
    { value: "远程处理", text: "远程处理" },
    { value: "电话沟通", text: "电话沟通" },
  ];
  onClickLeft() {
    window.history.go(-1);
  }
  async getPartsAllList() {
    await ajax.get("/api/parts/all-list").then((rep) => {
      this.partsAllList.push(...rep.data.result);
    });
  }
  async getById(id: any) {
    await ajax.get("/api/maintainrecord/by-id/" + id).then((rep) => {
      Object.assign(this.dispatchFormData, rep.data.result);
    });
  }
  async onSubmit() {
    if (!this.isUploadSuccess) {
      this.$toast.fail("图片上传成功后再提交");
      return false;
    }
    this.partsAllList.forEach((t: any) => {
      if (t.check) {
        this.dispatchFormData.partsList.push(t);
      }
    });
    this.dispatchFormData.fileUrls = this.uploadUrls;
    await ajax
      .post("/api/maintainrecord/statement-insert", this.dispatchFormData)
      .then(() => {
        this.$toast.success("结单成功");
        window.history.back();
      });
  }
  onConfirmHandleType(val: any) {
    this.dispatchFormData.handleType = val.value;
    this.showHandleType = false;
  }
  // 上传前置处理
  beforeRead(file: any) {
    if (!this.isUploadSuccess) {
      this.$toast.fail("上一张图片上传完成后再上传");
      return false;
    } else {
      return true;
    }
  }
  async afterRead(file: any) {
    this.isUploadSuccess = false;
    file.status = "uploading";
    file.message = "上传中...";

    // 大于1MB的图片都缩小像素上传
    if (file.file.size > 1024 * 1024) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = file.content;
      img.onload = async () => {
        // 1. 限制最大宽高，等比缩放
        const MAX_WIDTH = 1920;
        const MAX_HEIGHT = 1080;
        let { width, height } = img;

        if (width > MAX_WIDTH || height > MAX_HEIGHT) {
          const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        canvas.width = width;
        canvas.height = height;
        ctx!.drawImage(img, 0, 0, width, height);

        // 2. 强制输出为 JPEG，质量 0.6（PNG 图片也会被转成 JPEG）
        file.content = canvas.toDataURL("image/jpeg", 0.6);

        // 3. 将 base64 转回 File 对象（注意修改文件名后缀）
        const blob = await fetch(file.content).then((res) => res.blob());
        const compressedFile = new File(
          [blob],
          file.file.name.replace(/\.[^.]+$/, ".jpg"),
          {
            type: "image/jpeg",
          },
        );
        let fd = new FormData();
        fd.append("file", compressedFile);
        await ajax
          .post("/PutObject?maintainRecordNO=" + this.dispatchFormData.no, fd)
          .then((rep) => {
            if (rep.data.code === 1) {
              this.fileList = [];
            } else {
              this.isUploadSuccess = true;
              this.uploadUrls.push(rep.data.result[0].url);
              file.status = "done";
              file.message = "上传成功";
            }
          });
      };
    } else {
      let fd = new FormData();
      fd.append("file", file.file);
      await ajax
        .post("/PutObject?maintainRecordNO=" + this.dispatchFormData.no, fd)
        .then((rep) => {
          if (rep.data.code === 1) {
            this.fileList = [];
          } else {
            this.isUploadSuccess = true;
            this.uploadUrls.push(rep.data.result[0].url);
            file.status = "done";
            file.message = "上传成功";
          }
        });
    }
  }
  async created() {
    let id = this.$route.query.id;
    await this.getById(id);
    await this.getPartsAllList();
    let user = await this.getCurrentUser();
    this.userName = user.userName;
    this.uploadUrls = [];
  }
}
